import React from "react";

export default function Privacy() {
  return (
    <div className="grid grid-cols-1 gap-4">
      <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
        <div className="text-base font-semibold mb-2">Data Retention</div>
        <div className="flex items-center gap-3">
          <input type="number" defaultValue={90} className="w-24 bg-black/20 border border-white/20 rounded-xl px-3 py-2" />
          <span className="text-sm opacity-80">days</span>
          <button className="px-3 py-2 rounded-xl border border-white/20 bg-white/10 hover:bg-white/15 text-sm">
            Update
          </button>
        </div>
      </div>

      <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
        <div className="text-base font-semibold mb-2">Vendor Data Sharing</div>
        <label className="flex items-center gap-2 text-sm">
          <input type="checkbox" className="accent-cyan-400" defaultChecked />
          Allow anonymized telemetry sharing to improve device accuracy
        </label>
        <div className="text-xs opacity-60 mt-2">
          This maps to <span className="font-mono">/realms/{`{realm}`}/orgs/{`{org}`}/settings/vendorSharing</span>.
        </div>
      </div>
    </div>
  );
}
